export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth'
  },
  {
    action: 'view',
    subject: 'dashboard'
  },
  {
    action: 'read',
    subject: 'dashboard'
  }
]

export const _ = undefined
